import React from "react";
import { Modal, Typography } from "antd";

const { Title } = Typography;

type Props = {
  onClose: Function,
  open: Boolean,
}

const VerifyZellPaymentModal = (props: Props) => {
  const { onClose, open} = props;

  return (
    <Modal
      open={open}
      onCancel={onClose}
      closable={false}
      maskClosable={false}
      footer={null}
      centered
      width={700}
      styles={{
        content: {
          borderRadius: 20,
          padding: "40px 30px",
          textAlign: "center",
        },
      }}
    >
      <Title
        level={1}
        style={{
          fontWeight: 800,
          letterSpacing: 4,
        }}
      >
        YOUR PAYMENT PROCESSED SUCCESSFULLY
      </Title>
      <Title
        level={3}
        style={{
          marginTop: 20,
          letterSpacing: 3,
          fontWeight: 600,
        }}
      >
        You will be redirected automatically.
      </Title>
    </Modal>
  );
};

export default VerifyZellPaymentModal;